// src/components/services/ServicesHeader.jsx
import React from "react";

const ProductsHeader = () => {
  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const headerStyle = {
    background: "linear-gradient(to right, #000000, #0891b2)",
    color: "white",
    padding: "3rem 0",
    textAlign: "center",
  };

  const titleStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    margin: "0 0 1rem 0",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  };

  const subtitleStyle = {
    fontSize: "1.2rem",
    color: "#e0e0e0",
    margin: "0",
    paddingTop: "0.5rem",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  };

  return (
    <div style={headerStyle}>
      <div style={containerStyle}>
        <h1 style={titleStyle}>Our Products</h1>
        <p style={subtitleStyle}>
          Take a look at the products we stock. Contact us to check for
          availability.
        </p>
        <p style={subtitleStyle}>
          Don't see what you're looking for? Contact us to inquire about special
          orders and custom requests.
        </p>
        <p style={subtitleStyle}>
          All prices listed are before tax and add-ons. To view available
          add-ons, check the{" "}
          <a
            href="/service"
            style={{ color: "#7dd3fc", textDecoration: "underline" }}
          >
            services section
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default ProductsHeader;
